module.exports = __webpack_public_path__ + "img/icon-zoom.442ebbb3.svg";